import fetchById from './fetchById'
import create from './create'
export default {
    fetchById,
    create,
}
